import { listQuicksightDashboards } from "api/Workspace";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useAuthenticator } from "@aws-amplify/ui-react";

const DashboardList = (props) => {
  const [dashboardList, setDashboardList] = useState([]);
  const { user } = useAuthenticator((context) => [context.user]);

  useEffect(() => {
    listQuicksightDashboards(user.attributes.email)
      .then((res) => {
        console.log("listQuicksightDashboards", res);
        setDashboardList(res);
      })
      .catch((err) => {
        console.error("Error fetching dashboards:", err);
      });
  }, []);

  return (
    <div
      style={{
        padding: "29px 50px",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          color: "#2397CE",
          // marginLeft: 50,
          height: 30,
        }}
      >
        ダッシュボード一覧
      </div>
      <div style={{ padding: 20, backgroundColor: "#FFFFFF" }}>
        {dashboardList.map((dashboard) => (
          <Item key={dashboard.id} href={`/dashboard/${dashboard.id}`}>
            {dashboard.name}
          </Item>
        ))}
      </div>
    </div>
  );
};

const Item = styled.a`
  display: block;
  border: 1px solid #2397CE;
  padding: 10px;
  margin: 10px 0;
  text-decoration: none;
  width: calc(100% - 50px);
  color: #192e55;

  &:visited {
    color: #192e55;
  }

  &:hover {
    background-color: rgba(35, 151, 206, 0.1);
  }
  &:active {
    background-color: rgba(35, 151, 206, 0.2);
    color: #192e55;
  }
`;

export default DashboardList;
